import { getMainDefinition } from 'apollo-utilities'

const isFile = value => (
	(typeof File !== 'undefined' && value instanceof File) ||
  (typeof Blob !== 'undefined' && value instanceof Blob))

export const isUpload = ({ variables }) =>
	Object.values(variables).some(isFile)

export const isSubscriptionOperation = ({ query }) => {
	const { kind, operation } = getMainDefinition(query)
	return kind === 'OperationDefinition' && operation === 'subscription'
}
